module.exports = __webpack_public_path__ + "img/12_17.c2c1b47d.png";